import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import Modeling from 'diagram-js/lib/features/modeling/Modeling';
import TextRenderer from 'bpmn-js/lib/draw/TextRenderer';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {constants} from '@ispm-client/modules/bpmn-modeler/constants/constants';
import {OverlayUtils} from '@ispm-client/modules/bpmn-modeler/bpmn/utils/overlay-utils';
import {OverlayType} from '@ispm/shared/bpmn-io/overlay-types';
import {BpmnModelerConfig} from "@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-config";
import {get} from 'lodash';

export class CustomTextBehaviour extends CommandInterceptor {

  constructor(eventBus: EventBus, private modeling: Modeling, private textRenderer: TextRenderer, private overlays, private config: BpmnModelerConfig) {
    super(eventBus);
    super.postExecuted(EventType.UPDATE_LABEL, this.run.bind(this));
  }

  private run(event) {
    const context = event.context;
    const label = context.newLabel;
    const element = context.element;
    const nodeType = ModelingUtil.getNodeType(element);
    let newBounds;
    if (label) {
      const defaultDimensions = this.getNodeDefaultDimensions(element);
      newBounds = this.alignBounds(this.textRenderer.getExternalLabelBoundsByInput(element, label, defaultDimensions), element);
    }
    else {
      newBounds = {
        width: (nodeType == NodeType.treatment || nodeType == NodeType.neighborhood_entry) ? element.width : constants.NODE_DIMENSIONS.width,
        height: constants.NODE_DIMENSIONS.height,
        x: element.x,
        y: element.y
      };
    }

    if (nodeType === NodeType.neighborhood_entry || nodeType === NodeType.neighborhood_head) {
      const overlays = this.overlays.get({element: element});
        if (overlays && overlays.length > 0) {
            const res = this.getOverlayByType(overlays, OverlayType.neighborhoodHeadOverlay) || this.getOverlayByType(overlays, OverlayType.neighborhoodEntryOverlay);
            OverlayUtils.updateOverlayBounds(newBounds.height, res);
        }
    }

    newBounds.y -= (newBounds.height - element.height) / 2;
    this.modeling.resizeShape(element, newBounds, constants.NODE_DIMENSIONS);
  }

  private getOverlayByType(overlays, typeName) {
      return overlays.length > 0 ? overlays.find(overlay => overlay.type === typeName) : null;
  }


  private alignBounds(bounds, element) {
    const defaultDimensions = this.getNodeDefaultDimensions(element);
    const nodeType = ModelingUtil.getNodeType(element);
    bounds.x = element.x;
    bounds.y = element.y;
    bounds.width = defaultDimensions.width;
    bounds.height = Math.max(bounds.height, defaultDimensions.height);
    if (nodeType === NodeType.treatment && !get(this.config, 'verticalLayoutMode', false)) {
      bounds.height += constants.NEW_TEXT_ROW;
    }
    return bounds;
  }

  getNodeDefaultDimensions(element) {
    let defaultWidth = constants.NODE_DIMENSIONS.width;
    let defaultHeight = constants.NODE_DIMENSIONS.height;
    const nodeType = ModelingUtil.getNodeType(element);
    switch (nodeType) {
      case NodeType.normal:
        defaultWidth = constants.NODE_DIMENSIONS.width;
        break;
      case NodeType.neighborhood_entry:
      case NodeType.neighborhood_head:
        defaultWidth = constants.NEIGHBORHOOD_NODE_DIMENSIONS.width;
        break;
      case NodeType.treatment: {
        const verticalLayoutMode = get(this.config, 'verticalLayoutMode', false);
        defaultWidth = verticalLayoutMode ? constants.TREATMENT_NODE_VERTICAL_LAYOUT_DIMENSIONS.width : constants.TREATMENT_NODE_DIMENSIONS.width;
        defaultHeight = verticalLayoutMode ? constants.TREATMENT_NODE_VERTICAL_LAYOUT_DIMENSIONS.height : constants.TREATMENT_NODE_DIMENSIONS.height;
        break;
      }
      default:
        defaultWidth = constants.NODE_DIMENSIONS.width;
    }
    return { width: defaultWidth, height: defaultHeight};
  }

}

CustomTextBehaviour.$inject = [...CommandInterceptor.$inject, 'modeling', 'textRenderer', 'overlays', 'config'];
